import React from 'react';
import { useApp } from '../context/AppContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const UserSwitcher = () => {
  // Now safely destructured with currentUser available from context
  const { users, currentUser } = useApp();

  if (!currentUser) return null; // Safety check

  return (
    <div className="flex items-center gap-2 bg-white p-1 rounded-full border border-gray-200 shadow-sm">
      {users.map(user => (
        <div
          key={user.id}
          className={`
            flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium transition-all cursor-default
            ${currentUser.id === user.id 
              ? 'bg-gray-900 text-white shadow-md' 
              : 'text-gray-400 opacity-50'}
          `}
        >
          <div className={`w-2 h-2 rounded-full ${user.color}`} />
          {user.name}
        </div>
      ))}
    </div>
  );
};

export default UserSwitcher;